// Staff Member 3 profile - data-driven template.
// EDIT KARANA WIDIHA: src/data/staffData.js eke slug:"member3" block eka edit karanna.
// Nama, role, email, qualifications, specializations okkoma ethana maru wenawa.
// Photo: public/ ekata jpg dala photo: "/filename.jpg" kiyala staffData eke danna.
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import TopBar from "../components/TopBar";
import Header from "../components/Header";
import PreFooter from "../components/PreFooter";
import Footer from "../components/Footer";
import { getStaffBySlug } from "../data/staffData";

const THEME = "#1a3a2e";

function Avatar({ src, initials, bg }) {
  return (
    <div style={avatarWrapperStyle}>
      {src ? (
        <img
          src={src}
          alt={initials}
          style={avatarImgStyle}
          onError={(e) => {
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "flex";
          }}
        />
      ) : null}
      <div style={{ ...avatarInitialsStyle(bg), display: src ? "none" : "flex" }}>
        {initials}
      </div>
    </div>
  );
}

function Member3Profile() {
  const navigate = useNavigate();
  const cardRefs = useRef([]);
  const member = getStaffBySlug("nugaliyadda");

  useEffect(() => {
    window.scrollTo(0, 0);
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("animate-in");
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.1 }
    );
    cardRefs.current.forEach((el) => { if (el) io.observe(el); });
    return () => io.disconnect();
  }, []);

  if (!member) return null;
  const initials = member.name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();
  const first = member.name.split(" ")[0];
  const rest = member.name.split(" ").slice(1).join(" ");

  return (
    <>
      <TopBar />
      <Header activePage="about" />

      <section className="page-hero staff-hero">
        <div className="hero-pattern">
          {Array.from({ length: 32 }).map((_, i) => <span key={i} />)}
        </div>
        <div className="hero-text-block">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span className="breadcrumb-sep">›</span>
            <a href="/staff">Staff</a>
            <span className="breadcrumb-sep">›</span>
            <span>Profile</span>
          </div>
          <h2>{first} <span>{rest}</span></h2>
          <div className="hero-rule" />
          <p>{member.role} · Media &amp; Community Relations Centre</p>
        </div>
      </section>

      <section className="staff-section" style={{ padding: "70px 20px 90px" }}>
        <div className="staff-content" style={{ maxWidth: 1000 }}>

          <button onClick={() => navigate("/staff")} className="profile-back-btn" style={backBtnStyle}>
            ← Back to Staff
          </button>

          <div className="profile-identity js-card" ref={(el) => (cardRefs.current[0] = el)} style={identityCardStyle}>
            <Avatar src={member.photo} initials={initials} bg={THEME} />
            <div>
              <h2 style={identityNameStyle}>{member.name}</h2>
              <p style={identityRoleStyle}>{member.role}</p>
              <p style={identityDeptStyle}>
                Media &amp; Community Relations Centre, University of Peradeniya
              </p>
              <a href={`mailto:${member.email}`} style={emailLinkStyle}>{member.email}</a>
            </div>
          </div>

          <div style={topTwoGrid}>
            <div className="profile-section-card js-card" ref={(el) => (cardRefs.current[1] = el)} style={sectionCard}>
              <h3 style={sectionTitle(THEME)}>Educational Qualifications</h3>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {member.qualifications.map((q, i) => (
                  <li key={i} style={qualItemStyle}>
                    <span style={qualDot} />
                    <span>{q}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="profile-section-card js-card" ref={(el) => (cardRefs.current[2] = el)} style={sectionCard}>
              <h3 style={sectionTitle(THEME)}>Areas of Specialization</h3>
              <div style={pillsWrap}>
                {member.specializations.map((s, i) => (
                  <span key={i} style={pillStyle}>{s}</span>
                ))}
              </div>
            </div>
          </div>

          <div className="profile-section-card js-card" ref={(el) => (cardRefs.current[3] = el)} style={positionCard}>
            <h3 style={sectionTitle(THEME)}>Position Details</h3>
            <div style={metaGrid}>
              {[
                ["Institution", "University of Peradeniya"],
                ["Centre", "Media & Community Relations Centre"],
                ["Designation", member.role],
                ["Role", member.positionRole || member.role],
                ["Email", member.email],
              ].map(([label, value], i) => (
                <div key={i} style={metaItem}>
                  <div>
                    <p style={metaLabel}>{label}</p>
                    <p style={metaValue}>{value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      <PreFooter />
      <Footer />
    </>
  );
}

export default Member3Profile;

const backBtnStyle = {
  display: "inline-flex", alignItems: "center", gap: 8,
  marginBottom: 32, padding: "8px 20px",
  background: "transparent", border: `2px solid ${THEME}`,
  borderRadius: 40, color: THEME, fontWeight: 600, fontSize: 14,
  cursor: "pointer", transition: "all .25s",
};
const identityCardStyle = {
  display: "flex", alignItems: "center", gap: 32,
  background: "white", borderRadius: 16, padding: "36px 40px",
  boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
  marginBottom: 28, opacity: 0, transform: "translateY(40px)",
  transition: "opacity .65s ease, transform .65s ease",
};
const avatarWrapperStyle = {
  position: "relative", width: 180, height: 180, borderRadius: "50%",
  flexShrink: 0, overflow: "hidden",
  boxShadow: "0 6px 24px rgba(26,58,46,0.3)", border: `4px solid ${THEME}`,
};
const avatarImgStyle = { width: "100%", height: "100%", objectFit: "cover", objectPosition: "center top", display: "block" };
const avatarInitialsStyle = (bg) => ({
  position: "absolute", inset: 0, background: bg, color: "white",
  display: "flex", alignItems: "center", justifyContent: "center",
  fontFamily: "'Playfair Display', serif", fontSize: 42, fontWeight: 700,
});
const identityNameStyle = { fontFamily: "'Playfair Display', serif", fontSize: "clamp(18px, 2.5vw, 24px)", color: "#1a3a2e", marginBottom: 6, lineHeight: 1.3 };
const identityRoleStyle = { fontSize: 15, color: THEME, fontWeight: 600, marginBottom: 4 };
const identityDeptStyle = { fontSize: 14, color: "#555", marginBottom: 10 };
const emailLinkStyle = { fontSize: 14, color: THEME, textDecoration: "none", fontWeight: 500 };
const topTwoGrid = { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 22, marginBottom: 22 };
const sectionCard = {
  background: "white", borderRadius: 14, padding: "28px 30px",
  boxShadow: "0 2px 14px rgba(0,0,0,0.07)",
  opacity: 0, transform: "translateY(40px)",
  transition: "opacity .65s ease, transform .65s ease",
};
const positionCard = { ...sectionCard, marginBottom: 0 };
const sectionTitle = (color) => ({
  fontFamily: "'Playfair Display', serif", fontSize: 18,
  color, marginBottom: 18, paddingBottom: 10, borderBottom: `2px solid ${color}22`,
});
const qualItemStyle = { display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 12, fontSize: 14, color: "#333", lineHeight: 1.5 };
const qualDot = { width: 8, height: 8, borderRadius: "50%", background: THEME, flexShrink: 0, marginTop: 5 };
const pillsWrap = { display: "flex", flexWrap: "wrap", gap: 10, marginTop: 4 };
const pillStyle = { background: "#f0f5f2", border: "1px solid #d0ddd6", color: THEME, fontSize: 13, fontWeight: 500, padding: "6px 16px", borderRadius: 30 };
const metaGrid = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 18 };
const metaItem = { display: "flex", alignItems: "flex-start", gap: 12, background: "#f9f6f2", borderRadius: 10, padding: "14px 16px" };
const metaLabel = { fontSize: 11, color: "#888", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 3 };
const metaValue = { fontSize: 13.5, color: "#333", fontWeight: 500 };
